/**
 * FIXME - find a way to use notistack with css-in-js or styled components.
 * Tested `styled` function, and `sx` props
 */
.SnackbarContainerRoot {
  /**
  * Padding to accommodate device camera notch
  * See https://fathomtech.io/blog/designing-react-web-applications-for-the-notch/
  */
  padding-top: var(--safe-area-inset-top);
  padding-bottom: calc(var(--safe-area-inset-bottom) + 12px);
  padding-left: var(--safe-area-inset-left);
  padding-right: calc(var(--safe-area-inset-right) + 12px);

  /**
   * On mobile (<640px, matching Berlin md breakpoint), reposition to top-center.
   * The provider uses anchorOrigin bottom-right for desktop, but we override
   * the positioning via CSS for mobile.
   */
  @media (max-width: 639px) {
    top: 12px !important;
    bottom: auto !important;
    left: 50% !important;
    right: auto !important;
    transform: translateX(-50%);
    padding-bottom: 0;
    padding-right: var(--safe-area-inset-right);
  }
}
